import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AppRoutes from "./routes/AppRoutes";
import Notification from "./components/common/Notification/Notification";
import "./App.css";

function App() {
  return (
    <>
      <Notification />
      <AppRoutes />
      {/* One container for the whole app, so a page only has to call toast()
          without mounting anything of its own. */}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable={false}
        theme="light"
      />
    </>
  );
}

export default App;
